import Action from '../base/action';
import ConfigurationFactory from './configuration-factory';

class MeetingConfigurations extends Action {

    constructor(props) {
        super(props);
        this.meetingConfigurations = props.configurations;
    }

    async execute(eventLoop) {
        for (let configuration in this.meetingConfigurations) {
            if (this.meetingConfigurations.hasOwnProperty(configuration)) {
                ConfigurationFactory.setConfiguration(configuration, this.meetingConfigurations[configuration]);
            }
        }
    }
}

export default MeetingConfigurations;
